/* eslint-disable react/react-in-jsx-scope */
import { calculReportingProject } from "@/libs/utils";
import { useMemo } from "react";
import StatCardColoredSharing from "./StatColoredSharing";

const DataReporting = ({ program, project, valueCO, valueAC }) => {
  const dataReporting = useMemo(() => {
    if (!program) return [];
    const dr = calculReportingProject(program, null, [project], true, "project");
    return dr;
  }, [program, project]);

  return (
    <div className="relative w-full">
      {dataReporting?.projectTotalIndicators?.length === 0 && (
        <p className="m-0 text-center">Aucune donnée à afficher.</p>
      )}

      {dataReporting?.projectTotalIndicators?.length > 0 && (
        <StatCardColoredSharing
          showWarningFinancement={false}
          totalFinancement={0}
          totalSuivi={0}
          indicators={dataReporting.projectTotalIndicators}
          contributionObtenu={valueCO}
          appelAContribution={valueAC}
          context={null}
          indicatorsInitial={project?.indicators}
        />
      )}
    </div>
  );
};

export default DataReporting;
